import { LOGIN, LOGOUT } from '../actions/types';

const initialState = {
    user: {},
    isLoggedIn: false,
};

export default (state = initialState, { type, user }) => {
    switch (type) {
        case LOGIN:
            return {
                ...state,
                user,
                isLoggedIn: true,
            };
        case LOGOUT:
            return {
                ...state,
                user: {},
                isLoggedIn: false,
                accessToken: null,
            };
        default:
            return state;
    }
};
